import React, { Component } from 'react';
import AppRouter from './containers/AppRouter';
import configureStore from './store/store';
import { Provider } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import moment from 'moment';
moment.locale('es');
const store = configureStore();

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "rgba(1, 30, 136, 0.72)"
    },
    secondary: {
      light: "#CCC",
      main: "#333",
      dark: "#000"
    }
  }
});

class App extends Component {

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <AppRouter />
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js